import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=22fd61fc&scoped=true&"
import script from "./Video.js?vue&type=script&lang=js&"
export * from "./Video.js?vue&type=script&lang=js&"
import style0 from "./Video.vue?vue&type=style&index=0&id=22fd61fc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd61fc",
  null
  
)

export default component.exports